/* eslint-disable eqeqeq */
import consts from "./consts";
import {EventBus, history} from "./event-bus.js";
import {getSystemConfig} from "./systemConfig";

export default class LocalStorageManager {
	constructor(app) {
		console.info("created local storage manager");
		this.systemConfigPromise = getSystemConfig().then(config => {
			this.systemConfig = config;
			this.$emit("LSM:SystemConfigFetched", config);
			return config;
		});
		this.app = app;
		// this.systemConfig = null;
		this.keys = ["lang", "logo", "userType", "userName", "loginHistory", "faxDefaults"];
		this.defaults = {
			lang: "en", logo: window.whitelabelConfig.loginLogo, userType: null, userName: null, loginHistory: [], faxDefault: []
		};
		this.hasToken = false;
		this.PRODUCTS = consts.PRODUCT;
		this.$on("USER_LOGOFF", () => {
			console.info("remove items from local storage!");
			["current_customer", "auth_session", "currentLanguage", "displayed_customers", "token", "userType", "userName", "search_match", "search_search", "tokenExpire", "faxDefaults"].map(name => localStorage.removeItem(name));
			this.update();
		});

		this.$on("goToHistoryUser", index => {
			return this.returnToUserFromHistory(index);
		});

		this.$emit("LSM::start");
	}
	doLogout() {
		EventBus.$emit("USER_LOGOFF");
		if (history.location.pathname.indexOf("/login") === -1) {
			console.info("LSM#doLogout redirecting to login page");
			setTimeout(() => {
				location.href = "#/login/";
			}, 10);
		}
		else {
			console.info("LSM#doLogout already in login page");
		}
	}
	reset() {
		console.info("LSM RESET");
		this.cleanKeys();
		this.hasToken = false;
		this.update();
	}
	handleLogin() {
		EventBus.$emit("USER_LOGIN");
		return this.update();
	}
	update() {
		console.info("LSM UPDATE");
		if (!localStorage.token && this.hasToken) { // we had token but now we dont have it
			console.info("detected logout!");
			this.cleanKeys();
		}
		this.hasToken = localStorage.token;

		for (const prop of this.keys) {
			let currentValue = localStorage[prop];
			if (currentValue != null) {
				console.info(`LSM set ${prop} to ${currentValue}`);
				this.app[prop] = localStorage[prop];
			}
			else if (prop in this.defaults) {
				this.app[prop] = this.defaults[prop];
			}
		}
	}

	setLoginHistory(data) {
		console.warn("setLoginHistory", data);
		localStorage.setItem("loginHistory", JSON.stringify(data));
	}

	getLoginHistory() {
		return JSON.parse(localStorage.getItem("loginHistory") || "[]");
	}

	setFaxDefaults(data) {
		console.warn("setFaxDefaults", data);
		localStorage.setItem("faxDefaults", JSON.stringify(data));
	}

	getFaxDefault() {
		return JSON.parse(localStorage.getItem("faxDefaults") || "[]");
	}

	pushOrUpdateToLoginHistory(user) {
		console.warn("pushOrUpdateToLoginHistory", user);
		const MAX_HISTORY_ROWS = 20;
		let parentData = this.getLoginHistory();
		let historyIndex = Number(user.historyIndex);
		if (consts.PRODUCT.is(consts.PRODUCT.DIALER, user.userType && user.userType === "1")) {
			user.userName = user.userName + "-dialer";
		}
		let existingUser = parentData.find(historyUser => user.token === historyUser.token || user.userName === historyUser.userName);
		if (existingUser) {
			parentData[parentData.indexOf(historyIndex)] = user;
		}
		else {
			if (parentData.length >= MAX_HISTORY_ROWS) {
				parentData.shift();
			}
			const relativeIndex = parentData[parentData.length - 1]?.historyIndex + 1; // index based on previous index row
			user.historyIndex = relativeIndex || parentData.length;
			parentData.push(user);
		}
		this.setLoginHistory(parentData);
	}

	buildDataToHistory() {
		const masterUserName = localStorage.getItem("userName");
		const historyIndex = localStorage.getItem("historyIndex");
		let rawEnswitchCustomerData = JSON.parse(localStorage.getItem("current_customer") || "null");
		let enswitchCustomerDataToSave = rawEnswitchCustomerData ? {name: rawEnswitchCustomerData.name, id: rawEnswitchCustomerData.id} : null;
		const currentDate = new Date();
		const dateTimeString = currentDate.toISOString();
		return {token: localStorage.getItem("token"), userName: masterUserName, userType: localStorage.getItem("userType"), ensCust: enswitchCustomerDataToSave, logo: localStorage.getItem("logo"), dateTime: dateTimeString, historyIndex};
	}

	findNewUserInHistory(newUser) {
		let isDialerUser = consts.PRODUCT.DIALER == newUser.userType;
		let loginHistory = this.getLoginHistory();
		let matchingUser = loginHistory.find(user => user.userName == newUser.userName && (isDialerUser ? user.userType == consts.PRODUCT.DIALER : user.userType != consts.PRODUCT.DIALER));
		return matchingUser;
	}

	switchUser(newToken, userName, userType) {
		let activeUser = this.buildDataToHistory();
		this.updateHistoryIndex(userName, userType);
		this.pushOrUpdateToLoginHistory(activeUser);

		let newLogo = this.defaults.logo;

		if (newToken.token) {
			newLogo = newToken.logo;
			userType = newToken.userType;
			newToken = newToken.token;
		}

		localStorage.setItem("token", newToken);
		localStorage.setItem("userName", userName);
		localStorage.setItem("userType", userType || consts.PRODUCT.DIALER);
		localStorage.setItem("logo", newLogo == null ? newToken.logo : newLogo);

		// enswitch
		this.update();
		EventBus.$emit("USER_SWITCH");
	}

	updateHistoryIndex(userName, userType) {
		let matchingUser = this.findNewUserInHistory({userName, userType});
		if (matchingUser) {
			console.info("switchUser", "found match", matchingUser);
			localStorage.setItem("historyIndex", matchingUser.historyIndex);
		}
		else {
			console.info("switchUser", "not found match");
			localStorage.removeItem("historyIndex");
		}
	}

	returnToUserFromHistory(historyIndex) {
		let loginHistory = this.getLoginHistory();
		if (historyIndex >= loginHistory.length) {
			console.error("switch user: invalid index " + historyIndex);
			return;
		}
		let newUser = loginHistory[historyIndex];
		let activeUser = this.buildDataToHistory();
		this.pushOrUpdateToLoginHistory(activeUser);
		this.setUserToLocalStorage(newUser);
		this.update();
		EventBus.$emit("USER_SWITCH");
		if (this.app.isPBXActive && consts.PRODUCT.is(consts.PRODUCT.PBX)) {
			EventBus.$emit("user:switched");
		}
		// TODO: else if the new user type cannot access the current route
		else {
			document.location.reload();
		}
	}

	setUserToLocalStorage(selectedUser) {
		console.info("set token to parent token");
		localStorage.setItem("token", selectedUser.token);
		localStorage.setItem("userName", selectedUser.userName);
		localStorage.setItem("userType", selectedUser.userType);
		localStorage.setItem("logo", selectedUser.logo);

		// enswitch
		if (selectedUser.ensCust) {
			console.log("LSM set current_customer to", selectedUser.ensCust);
			localStorage.setItem("current_customer", JSON.stringify(selectedUser.ensCust));
		}
		else {
			console.log("LSM clean current_customer");
			localStorage.removeItem("current_customer");
		}
		if (!isNaN(Number(selectedUser.historyIndex))) {
			localStorage.setItem("historyIndex", selectedUser.historyIndex);
		}
		else {
			localStorage.removeItem("historyIndex");
		}
	}

	cleanKeys() {
		console.info("LSM CLEAN");
		for (const prop of this.keys) {
			let currentValue = localStorage[prop];
			if (currentValue && prop != "lang") {
				console.info("clean " + prop);
				localStorage.removeItem(prop);
			}
		}
	}

	$on(...args) {
		return EventBus.$on(...args);
	}

	$emit(...args) {
		return EventBus.$emit(...args);
	}
}
